import React, { useState, useRef, useEffect } from "react";
import { Layout, List, Input, Button, Avatar } from "antd";
import { UserOutlined, RobotOutlined, HomeFilled } from "@ant-design/icons";
import Header from "components/VerticalLayout/Header";
import { useDispatch, useSelector } from "react-redux";
import { getConversations, sendMessageToAgent } from "store/auth/agent/agentSlice";
import { message } from "antd";
import { getProfile } from "store/auth/profile/profileSlice";
import { Link, useParams } from "react-router-dom";
import { socket } from "../../common/services/socket";

const { Content, Footer } = Layout;

const ChatInterface = () => {
    const dispatch = useDispatch();
    const conversations = useSelector((state) => state.Agents.conversations);
    const profile = useSelector((state) => state.Profile.profile);
    const { agentToChat } = useSelector(state => state.Agents);
    // const messageToAgent = useSelector((state) => state.Agents.message);
    const { agentId } = useParams();

    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const messagesEndRef = useRef(null);

    const token = localStorage.getItem("auth_token");

    useEffect(() => {
        if (!token) {
            if (socket.connected) socket.disconnect();
            return;
        }
        socket.auth = { token };

        if (!socket.connected) {
            socket.connect();
        }
        return () => {
            socket.disconnect();
        };
    }, [token])


    useEffect(() => {
        const onOnline = () => {
            if (!socket.connected) {
                socket.connect();
            }
        };
        window.addEventListener("online", onOnline);
        return () => window.removeEventListener("online", onOnline);
    }, []);
    async function fetchProfile() {
        await dispatch(getProfile());
    }

    useEffect(() => {
        fetchProfile();
    }, [dispatch]);

    const handleReceive = async () => {
        if (agentId && profile?._id) {
            await dispatch(getConversations(profile._id));
        } else {
            fetchProfile();
        }
    };

    useEffect(() => {
        socket.on('receiveMessage', handleReceive);
        socket.on('messageSent', handleReceive);
        socket.on('messageError', ({ error }) => {
            message.error(error);
        });

        return () => {
            socket.off('receiveMessage', handleReceive);
            socket.off('messageSent', handleReceive);
            socket.off('messageError');
        };
    }, []);


    useEffect(() => {
        if (profile?._id) {
            dispatch(getConversations(profile._id));
        }
    }, [dispatch, profile]);

    useEffect(() => {
        if (conversations?.length && agentId && profile?._id) {
            const filtered = conversations
                .filter(
                    (conv) =>
                        (conv.sender === agentId && conv.receiver === profile._id) ||
                        (conv.receiver === agentId && conv.sender === profile._id)
                )
                .sort(
                    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
                );
            setMessages(filtered);
        }
    }, [conversations, agentId, profile]);


    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const sendMessage = () => {
        if (!agentId || input.trim() === "") return;
        if (!socket.connected) {
            socket.connect();
        }
        const payload = {
            receiverId: agentId,
            message: input.trim(),
            senderModel: "Player",
            receiverModel: "Agent",
        };

        socket.emit("sendMessage", payload);
        // dispatch(sendMessageToAgent(payload));

        setInput("");
    };


    return (
        <Layout style={{ backgroundColor: "#f0f2f5" }}>
            <Content style={{ display: "flex", justifyContent: "center", padding: 20 }}>
                <div
                    style={{
                        backgroundColor: "#fff",
                        borderRadius: 8,
                        // padding: "0 20px",
                        width: "100%",
                        maxWidth: 800,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        display: "flex",
                        flexDirection: "column",
                        maxHeight: "calc(100vh - 120px)",
                        overflow: "hidden",
                        minHeight: 500,
                    }}
                >
                    {/* Header du Chat */}
                    <div className="sticky-top d-flex justify-content-center align-items-center p-4 bg-white">
                        <Link
                            to="/accueille"
                            className="d-flex justify-content-center align-items-center bg-primary text-white rounded-circle text-decoration-none"
                            style={{ width: 48, height: 48, transition: "transform .2s" }}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}>
                            <HomeFilled />
                        </Link>
                    </div>

                    {/* Liste des messages */}
                    <div style={{ flex: 1, overflowY: "auto", paddingBottom: 20, padding: "0 20px", }}>
                        <List
                            dataSource={messages}
                            renderItem={(item) => (
                                <List.Item
                                    key={item._id}
                                    style={{
                                        display: "flex",
                                        justifyContent: item.sender === agentId ? "flex-start" : "flex-end",
                                        padding: "10px 0",
                                    }}
                                >
                                    {item.sender === agentId ? (
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <Avatar icon={<RobotOutlined />} />
                                            <div style={{ marginLeft: 8 }}>
                                                <div style={{ fontWeight: "bold" }}>{agentToChat.firstName} {agentToChat.lastName}</div>
                                                <div style={{ textAlign: "left" }}>{item.message}</div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ display: "flex", alignItems: "center", flexDirection: "row-reverse" }}>
                                            <Avatar icon={<UserOutlined />} />
                                            <div style={{ marginRight: 8, textAlign: "right" }}>
                                                <div style={{ fontWeight: "bold" }}>{profile.username}</div>
                                                <div>{item.message}</div>
                                            </div>
                                        </div>
                                    )}
                                </List.Item>
                            )}
                        />
                        <div ref={messagesEndRef} />
                    </div>

                    {/* Zone de saisie et bouton Envoyer */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px",
                            borderTop: "1px solid #f0f0f0",
                            backgroundColor: "#fff",
                            position: "sticky",
                            bottom: 0,
                            zIndex: 1,
                        }}
                    >
                        <Input.TextArea
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            placeholder="Tapez votre message ici..."
                            autoSize={{ minRows: 1, maxRows: 3 }}
                            style={{ flex: 1, marginRight: 10 }}
                        />
                        <Button type="primary" onClick={sendMessage} disabled={!profile}>
                            Envoyer
                        </Button>
                    </div>
                </div>
            </Content>
        </Layout>
    );

};

export default ChatInterface;
